import { useState } from "react";
import { withProcedureWraper } from "../../../..";
import {
  ApprovalHistory,
  Box,
  BoxSection,
  Chats,
  IChat,
  Icon,
  Steps,
} from "../../../../../../components";
import { ECEnDetail, ECViDetail } from "../../components";
import { useHistory } from "react-router-dom";
import { Button } from "../../../../../../modules/button";

const EmployeeConfirmationDetail = withProcedureWraper(() => {
  const history = useHistory();
  const [chats, setChats] = useState<IChat[]>([]);
  const language = "vi";

  const onChatChange = (chats: any[]) => {
    setChats(chats);
  };

  return (
    <div className="pd15">
      <div className="PageHead flex-center">
        <div className="title" style={{ margin: 0 }}>
          <div className="btnBack" onClick={() => history.goBack()}>
            <Icon.ArrowLeft />
          </div>
          XEM XÉT YÊU CẦU DUYỆT
        </div>
      </div>
      <Box title="Quy trình duyệt">
        <Steps
          current={2}
          status="finish"
          items={[
            {
              title: "Khởi tạo",
              stepContent: {
                name: "Can bo 1-VIAGS",
                email: "canbo1@viags.vn",
                actionText: "Ngày tạo:",
                date: "12/10/2023 11:39",
              },
            },
            {
              title: "Thủ trưởng đơn vị",
              stepContent: {
                name: "Huỳnh Thông",
                email: "canbo1@viags.vn",
              },
            },
            {
              title: "Bộ phận hành chính TCNL",
              stepContent: {
                name: "Nguyễn Văn Thanh",
                email: "canbo2@viags.vn",
              },
            },
            {
              title: "Trưởng phòng TCNL",
              stepContent: {
                name: "Trần Thanh Tâm",
                email: "botit@viags.vn",
              },
            },
          ]}
        />
      </Box>
      <Box title="Thông tin">
        {language === "vi" ? <ECViDetail /> : <ECEnDetail />}
        <BoxSection title="Lịch sử phê duyệt">
          <ApprovalHistory
            items={[
              {
                name: "Can bo 1-VIAGS",
                status: "Approved",
                date: "12/10/2023 11:39",
                reason: "test",
              },
              {
                name: "Can bo 2-VIAGS",
                status: "Approved",
                date: "15/10/2023 11:39",
              },
              {
                name: "Can bo 3-VIAGS",
                status: "Completed",
                date: "15/11/2023 11:39",
              },
            ]}
          />
        </BoxSection>
        <BoxSection title="Thông tin trao đổi">
          <Chats items={chats} onChange={onChatChange} />
        </BoxSection>
      </Box>
      <div className="flex-center">
        <Button className="mr5" buttonType="success" label="Đồng ý" />
        <Button className="mr5" buttonType="grey" label="Không đồng ý" />
      </div>
    </div>
  );
});

export default EmployeeConfirmationDetail;
